import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./AddressFinderHome.html');
//import "../AddressFinder/AddressFinderTypes";
import AddressWizard from '../AddressWizard/AddressWizard';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import { AddressTypes, AddressTypes as Types, Classnames } from "../_loadingHelpers/Address";
//import emailFormStandalone = require("../EMail/emailFormStandalone");
import emailForm from '../EMail/emailForm';
import ExternalFormsList from '../ExternalForms/ExternalFormsList/ExternalFormsList';
import VCardGenerator from '../VCardGenerator/VCardGenerator';
import { SelectEntityDialog, SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import { EmailEditorTypes } from "../EMail/emailTypes";
import _WidgetBase from 'dijit/_WidgetBase';



class AddressView extends compose(_EntityViewMixin<Types.AddressEntity_Base>) {
    //templateString = template; // nur falls nötig ein eigenes laden!
    private editor: MdsLax<InstanceType<typeof AddressWizard>> = null;

    private externalFormsList: MdsLax<InstanceType<typeof ExternalFormsList>>;

    /**
     *
     * @param entityId
     * @param label
     * @param additionalParams
     * @param tabContainerName
     * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
     */
    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
    }

    onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {
        if (this.editingAllowed) {
            this.editor = new AddressWizard();
            this.editor.startup();

            if (this.dlg) this.dlg.close(-1, true);
            if (this.createNewTabbedContent({
                enableClosing: true,
                name: "addressWizard_" + entityID,
                sidebarEntryName: entityID,
                label: this.title,
                widget: this.editor,
                groupLabel: this.title,
                targetContainerName: this.tabContainerName,
            }, true, true) == true) {
                // hat funktioniert, Addresswizard ist im Tab
            } else {
                let dlg = new GenericDialog();
                dlg.closeOnEnter = false;
                dlg.closeOnEscape = false;
                dlg._setTopCloseBtnAttr(true);
                dlg.keepOpen = true;
                //dlg.setUserdefinedButton(this.translations["AddressWizard__done"],
                //    null,
                //    lang.hitch(this, this._onWizardDone, dlg, this.editor))


                //dlg.enableContentOverflow(true);

                dlg.show(this.editor,
                    this.title,
                    null,
                    null,
                    "saveclose",
                    lang.hitch(this, this._confirmCallback, dlg, this.editor));
            }

            this.editor.setup(entityID);
            //this.editor.on("saved", lang.hitch(this, this.onEntityChange));
            return this.editor;
        }
    }

    onShow() {
        // zb weitere Buttons zum Dlg oder in den Tab einfügen...

    }

    onViewContentSet() {
        if (this.hasFeature("Address/VCardGenerator")){
            this.addButton(
                "vcardGenerator",
                this.translate("AddressWizard__Label_VCardGenerator"),
                lang.hitch(this, this._onClickButtonVCardGenerator),
                this.translate("AddressWizard__Label_VCardGenerator"),
                null,
                "fas fa-address-card",
                null,
                "left first"
            );
        }
        //console.debug(this.id + " onViewContentSet", this.hasFeature("Email", "AddressView_CreateMail"), this.hasUserRole("Email_Editor") );
        if (this.hasFeature("Email", "AddressView_CreateMail")) {
            if (this.hasUserRole("Email_Editor")) {
                this.addButtonMenu("email", this.translate("General_Label_Email"), "fas fa-at", true, null);

                this.addButton("email",
                    "email_mailFormStandalone_CreateNew",

                    lang.hitch(this, this.showMailEditor),
                    null,
                    null,
                    "fas fa-envelope-open-text",
                    false,
                    "left first",
                    true, false, true,
                    "email");

                if (this.viewData.entityClassname === Classnames.organisations_internal && this.hasFeature("Email", "AdressView_BulkMail")) {
                    this.addButtonMenu("bulkMailAssociates", this.translate("BulkMail_Label_Associates"), "fas fa-user-alt", true, "email");

                    this.addButton(
                        "auto", this.translate("BulkMail_Label_Auto"),
                        lang.hitch(this, this._onClickBulkMailBtn, "organisation_internal_associates", true),
                        null, null, "fas fa-mail-bulk", false, "left last", true, false, true, "bulkMailAssociates");


                    this.addButton(
                        "select", this.translate("BulkMail_Label_Select"),
                        lang.hitch(this, this._onClickBulkMailBtn, "organisation_internal_associates", false),
                        null, null, "fas fa-mouse-pointer", false, "left last", true, false, true, "bulkMailAssociates");
                }


                //this.addButton(
                //    "formGroup",
                //    "Test",
                //    null,
                //    null,
                //    null,
                //    null,
                //    false,
                //    "left last",
                //    true,
                //    true,
                //    false,
                //    null
                //)



                this.addButton(
                    "externalFormIban",
                    "General_Label_ExternalFormIbanButton",
                    lang.hitch(this, this._onClickButtonExternalForm, "iban"),
                    null,
                    null,
                    "fas fa-credit-card",
                    false,
                    "left last",
                    true,
                    false,
                    true,
                    "externalFormMenu"

                );

                this.addButton(
                    "externalFormAddress",
                    "General_Label_ExternalFormAddressButton",
                    lang.hitch(this, this._onClickButtonExternalForm, "address"),
                    null,
                    null,
                    "fas fa-address-card",
                    false,
                    "left last",
                    true,
                    false,
                    true,
                    "externalFormMenu"
                );

                this.addButtonMenu(
                    "externalFormMenu",
                    "AddressView_Label_ExternalFormMenu",
                    "fas fa-file-alt",
                    true,
                    null
                );
            }
        }

        let classname = this.viewData.entityClassname;
        if (this.hasFeature("Address/UpgradeClasslevel") && classname === "organisations_internal") {
            this.addButton(
                "upgradeClasslevel",
                "AddressView_Label_UpgradeClasslevel",
                lang.hitch(this, this._onClickButtonUpgradeClasslevel),
                null,
                null,
                "fas fa-graduation-cap",
                false,
                "left last",
            );
        }


    }

    private _onClickBulkMailBtn(mode: string, autoSelect: boolean = true) {

        this.StandbyStart();
        if (autoSelect) this.RequestManager.callfunction("Webtool_API_BulkMail_GetMailAddresses", { mode, entityId: this.entityID }, lang.hitch(this, this._onRequestAssociatesEmailAddressesResponse), lang.hitch(this, this._onRequestAssociatesEmailAddressesError));
        else this.RequestManager.callfunction("Webtool_API_BulkMail_SED_GetConfig", { mode }, lang.hitch(this, this._onSEDConfigResponse, mode), lang.hitch(this, this._onSEDConfigError));
    }

    private _onSEDConfigResponse(mode: string, response: SelectEntityDialogTypes.DlgConfiguration<any>) {
        this.StandbyStop();
        let selectEntityDialog = new SelectEntityDialog();
        selectEntityDialog.setConfiguration(response, lang.hitch(this, this._onSEDCallback, mode));
        selectEntityDialog.addRequestParameter("mode", mode);
        selectEntityDialog.addRequestParameter("entityId", this.entityID);
        selectEntityDialog.show();
    }

    private _onSEDConfigError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onSEDCallback(mode: string, values: Array<string>, items: Array<SelectEntityDialogTypes.Item<UserEmail>>) {
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        switch (mode) {
            case "organisation_internal_associates":
                for (let item of items) {
                    mailAddressArray.push({ entityID: item.entry.data.ID, mailaddress: item.entry.data.telecom_code });
                } 
                this.showMailEditor(this.title, null, true);
                this.mailform.setToBulkmail(null, mailAddressArray);
                break;
        }
    }

    private _onRequestAssociatesEmailAddressesResponse(response: Array<UserEmail>) {
        this.StandbyStop();
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        for (let address of response) {
            mailAddressArray.push({ entityID: address.ID, mailaddress: address.telecom_code });
        }
        this.showMailEditor(this.title, null, true);
        this.mailform.setToBulkmail(null, mailAddressArray);
    }

    private _onRequestAssociatesEmailAddressesError(error) {
        this.StandbyStop();
        console.error(error);
    }

    protected onDataLoaded() {
        this._setupExternalFormsList();
    }

    protected onReload() {
        this._setupExternalFormsList();
    }

    private _setupExternalFormsList(bOverridePrivilege?: boolean) {
        let priv = this.hasUserRole("Address__ExternalFormsList");
        if (typeof (bOverridePrivilege) == "boolean") priv = bOverridePrivilege;

        if (!priv) return;
        if (!this.entityID) return;

        this.externalFormsList = new ExternalFormsList();
        this.externalFormsList.setup("vt_addresses", this.entityID);
        this.addContent(this.externalFormsList.domNode);
    }

    private vcardGenerator: MdsLax<InstanceType<typeof VCardGenerator>> = null;
    private _onClickButtonVCardGenerator(){
        let entityId = this.entity?.ID ?? this.entityID;
        if (typeof entityId != 'string'){
            this.showToast("invalid entity id - cannot open editor");
            console.error("entity id invalid, cannot start vcard generator", this.entity, this.entityID);
            return;
        }
        if (typeof this.vcardGenerator != 'undefined' || this.vcardGenerator == null){
            try{
                this.vcardGenerator.destroyRecursive();
            }catch{}
            this.vcardGenerator = null;
        }
        this.vcardGenerator = new VCardGenerator(entityId);
    }
    private _onClickButtonUpgradeClasslevel() {
        let callfunction = "Webtool_API_AddressFinder__UpgradeClasslevel";
        this.StandbyStart();

        this.RequestManager.callfunction(callfunction, { entityID: this.entityID }, lang.hitch(this, this._onUpgradeClasslevelResponse), lang.hitch(this, this._onUpgradeClasslevelError));
    }

    private _onUpgradeClasslevelResponse(response) {
        this.StandbyStop();
        this.showToast("AddressView_Success_UpgradeClasslevel", "fas fa-check");
    }

    private _onUpgradeClasslevelError(error) {
        this.StandbyStop();
        this.showToast(error.Message, "fas fa-excalamation-triangle");
    }

    private _onClickButtonExternalForm(type: string, e) {
        let callfunction = "Webtool_API_AddressFinder__GetExternalForm";
        this.StandbyStart();

        this.RequestManager.callfunction(callfunction, { entityID: this.entityID, type: type }, lang.hitch(this, this._onGetExternalFormResponse), lang.hitch(this, this._onGetExternalFormError))
    }

    private _onGetExternalFormResponse(response) {
        this.StandbyStop();

        if (this.externalFormsList && this.hasUserRole("Address__ExternalFormsList")) this.externalFormsList.reload();

        let type = response.type;
        let link = response.link;

        let content;
        let subject;

        switch (type) {
            case "iban":
                content = "<p>" + this.translate("Email_Content_IbanForm") + "</p>";
                content += `<br><p><a href="${link}">${this.translate("Email_Content_ToForm")}</a></p>`;
                subject = this.translate("Email_Subject_IbanForm");
                break;
            case "address":
                content = "<p>" + this.translate("Email_Content_AddressForm") + "</p>";
                content += `<br><p><a href="${link}">${this.translate("Email_Content_ToForm")}</a></p>`
                subject = this.translate("Email_Subject_AddressForm");
                break;
        }



        this.showMailEditor(subject, content);
    }

    private _onGetExternalFormError(error) {
        this.StandbyStop();
        console.error(error);
    }

    //mail stuff
    //private flagMailFormWasInit = false;
    private mailform: MdsLax<InstanceType<typeof emailForm>>;

    private showMailEditor(subject?: string, content?: string, isBulkMail = false) {
        //TODO weniga gage email addresse rauspicken
        try{
            var targetMailForMailButton = this.viewData.content.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)[0];
        }catch{

        }
        this.mailform = new emailForm();
        this.mailform.setMailFormContext({
            isHistoryContext: true,
            contextEntity: {
                ID: this.entityID,
                Classname: this.config.entityClassname
            }
        });


        if (targetMailForMailButton && !isBulkMail) {
            this.mailform.addRecipients("to", [{ mailaddress: targetMailForMailButton, entityID: null }]);
        } else if (!isBulkMail) {
            this.mailform.loadRecipientAddress("to", this.entityID);
        }

        if (typeof subject == 'string') {
            this.mailform.setSubject(subject);
        }
        if (typeof content == 'string') {
            this.mailform.addContent(content);
        }

        this.mailform.show("dlg", null, this.getTabContainerName());

    }
    //##############

    onDelete() {

    }

    afterDelete() {

    }

    onClose() {


    }

    private _onWizardDone(dlg: MdsLax<InstanceType<typeof GenericDialog>>, editor: MdsLax<InstanceType<typeof AddressWizard>>) {
        let hasChanged = editor.isDirty();
        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesno",
                lang.hitch(this, this._confirmCallback, dlg, editor));

        } else {
            dlg.close();
        }
    }

    private _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof AddressWizard>>, result) {
        if (result <= 0) {
            dlg.close(-1, true);
        } else {
            form.submitFormData();
        }

    }




    postCreate(): void {

        this.config = {
            entityClassname: Classnames.vt_addresses, // ?? ohne konkretes Entity schwierig
            labelProperty: "gDisp_1",
            entityClassPrintname: this.translate("General_Address"),
            editOptions: {
                userroleEdit: "Addresses_Edit",
                featurePathEdit: "Address/AddressWizard",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            },
            deleteOptions: {
                userroleDelete: "Addresses_Delete",
                featurePathDelete: null,
            }
        }
        super.postCreate.apply(this, arguments as any);


    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AddressView);
